document.addEventListener('DOMContentLoaded', () => {
  const bars = document.querySelectorAll('[data-crg-mobile-buybar]');
  if (!bars.length) return;

  bars.forEach((bar) => {
    const sectionId = bar.dataset.sectionId;
    const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const info = document.getElementById(`ProductInfo-${sectionId}`);
    const stickyButton = bar.querySelector('[data-crg-sticky-add]');
    const stickyPrice = bar.querySelector('[data-crg-sticky-price]');
    if (!mainButton || !info || !stickyButton) return;

    const sync = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || 'ADD TO CART';
      const priceRoot = info.querySelector('[id^="price-"] .price');
      const livePrice = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      if (livePrice && stickyPrice) stickyPrice.textContent = livePrice.textContent.trim();
    };

    stickyButton.addEventListener('click', () => mainButton.click());

    let mainVisible = true;
    let productEntered = false;
    const refresh = () => {
      const visible = productEntered && !mainVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const buttonObserver = new IntersectionObserver((entries) => {
      mainVisible = entries[0]?.isIntersecting ?? true;
      refresh();
    }, { threshold:0.01 });
    buttonObserver.observe(mainButton);

    const infoObserver = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) productEntered = true;
      refresh();
    }, { rootMargin:'0px 0px -28% 0px', threshold:0.01 });
    infoObserver.observe(info);

    const priceNode = info.querySelector('[id^="price-"]');
    const mutation = new MutationObserver(sync);
    mutation.observe(mainButton, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled'] });
    if (priceNode) mutation.observe(priceNode, { childList:true, subtree:true, characterData:true });
    sync();
  });
});

// Club Rehab visual variant picker search + selected label helper
(() => {
  const bindCrgVisualVariantPickers = (root = document) => {
    const pickers = root.querySelectorAll('[data-crg-visual-picker]');
    if (!pickers.length) return;
    pickers.forEach((picker) => {
      if (picker.dataset.crgBound === 'true') return;
      picker.dataset.crgBound = 'true';
      const search = picker.querySelector('[data-crg-variant-search]');
      const selected = picker.querySelector('[data-selected-value]');
      if (search && !picker.closest('variant-selects[data-product-id="8020078919872"]')) {
        search.addEventListener('input', () => {
          const q = search.value.trim().toLowerCase();
          picker.querySelectorAll('[data-crg-variant-option]').forEach((tile) => {
            tile.hidden = !!q && !((tile.dataset.valueText || '').includes(q));
          });
        });
      }
      picker.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]') && selected) selected.textContent = event.target.value;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindCrgVisualVariantPickers());
  else bindCrgVisualVariantPickers();
  document.addEventListener('shopify:section:load', (e) => bindCrgVisualVariantPickers(e.target));
})();

// Club Rehab V79: keep the primary purchase controls beside the price.
(() => {
  const placeFastBuyRow = (root = document) => {
    root.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      // Audited weights keep gram selection before quantity and purchase.
      if (section.querySelector('[data-crg-weight-gallery]') || section.classList.contains('crg-gp-product') || section.classList.contains('crg-rf-product') || section.classList.contains('crg-default-product')) return;
      const info = section.querySelector('[id^="ProductInfo-"]');
      if (!info || info.querySelector('.crg-price-buy-row')) return;

      const price = info.querySelector('[id^="price-"]');
      const quantity = info.querySelector('.product-form__quantity');
      const productForm = info.querySelector('product-form.product-form');
      if (!price || !productForm) return;

      const row = document.createElement('div');
      row.className = 'crg-price-buy-row';
      price.parentNode.insertBefore(row, price);

      row.appendChild(price);
      if (quantity) row.appendChild(quantity);
      row.appendChild(productForm);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => placeFastBuyRow());
  } else {
    placeFastBuyRow();
  }
  document.addEventListener('shopify:section:load', (event) => placeFastBuyRow(event.target));
})();



(() => {
  let observer;
  let area;
  const clear = () => {
    observer?.disconnect();
    document.body.classList.remove('crg-purchase-info-visible');
  };
  const bind = () => {
    clear();
    area = document.querySelector('main [id^="ProductInfo-"]');
    if (!area) return;
    observer = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('crg-purchase-info-visible', entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(area);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', (event) => {
    if (area && event.target.contains(area)) clear();
  });
})();

// Keep the exact stamper search available after native variant HTML replacement.
document.addEventListener('input', (event) => {
  if (!event.target.matches('variant-selects[data-product-id="8020078919872"] [data-crg-variant-search]')) return;
  const picker = event.target.closest('[data-crg-visual-picker]');
  const query = event.target.value.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  let count = 0;
  picker.querySelectorAll('[data-crg-variant-option]').forEach((tile) => {
    tile.hidden = !!query && !(tile.dataset.valueText || '').replace(/[^a-z0-9]/g, '').includes(query);
    if (!tile.hidden) count++;
  });
  const status = picker.querySelector('[data-crg-stamp-count]');
  if (status) status.textContent = query ? `${count} matching choices` : '53 choices';
});
